import SkRequest from './BaseRequest';
import { MutationBuilder } from '../queryBuilder';
import { actionHandlerWithFeatureFlag } from '../../utils';
import {
  msUpdateSchoolConfig,
  msGetSchoolLogoUploadURL,
} from '../../services/SchoolConfigService';
import { FEATURE_FLAGS } from '../../utils/constants';
import DatadogHandler from '../../utils/datadog';

const _mMutationBuilder = new MutationBuilder();

_mMutationBuilder.setNewMutation('updateSchoolConfig', {
  ID: 'number',
  key: 'string',
  value: 'string',
});

_mMutationBuilder.setNewMutation('getSchoolLogoUploadURL', {
  Url: 'string',
  Key: 'string',
});

export const monoUpdateSchoolConfig = async (_, reqData) => {
  const query = _mMutationBuilder.getBulkMutationAsString({
    updateSchoolConfig: reqData,
  });
  try {
    const data = await SkRequest({
      data: {
        query,
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    return ex;
  }
};

export const monoGetSchoolLogoUploadURL = async (_, reqData) => {
  const query = _mMutationBuilder.getMutationAsString(
    'getSchoolLogoUploadURL',
    reqData
  );

  try {
    const data = await SkRequest({
      data: {
        query,
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const getSchoolLogoUploadURL = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: monoGetSchoolLogoUploadURL,
      monoHandler: msGetSchoolLogoUploadURL,
      extraData: reqData,
    }
  );
};

export const updateSchoolConfig = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msUpdateSchoolConfig,
    monoHandler: monoUpdateSchoolConfig,
    extraData: reqData,
  });

export default updateSchoolConfig;
